/* global $ */
$.$body.find('.accordion__header').on('click', function() {
  $(this).toggleClass('accordion__open');
  $(this)
    .siblings('.accordion__body')
    .slideToggle();
});
